// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"167":"aa454840","372":"41a7a6ce","496":"b6f06c26"}[chunkId] + ".css";
};